/* eslint-disable no-use-before-define,eqeqeq */
import React from 'react'
import { Chart } from './history/chart'
import { Table } from './history/table'

export const PriceHistory = ({context}) => {
    const n = context.filterByDate
    
    return <React.Fragment>
        <div className="row">
        <h4 className="col-md-12 text-medium" style={{fontSize: 'inherit'}}>Price history chart for {n == 0 ? 'today' : `last ${n} days`}</h4>
        </div>

        <Chart context={context} />
        <Table context={context} />
    </React.Fragment>
}

